<template lang="pug">
</template>
<script>
import gql from 'graphql-tag'
import graphql from '@/components/Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import LoginModal from '@/components/Account/LoginModal'
import moment from 'moment'
export default {
  components: {
    MdNotification
  },
  data() {
    return {
      item: [],
      isJoin: 0,
      message: this.$t('home.comming_soon')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    doHistoryBrowser(classesID = 0) {
      if (classesID === 0) this.$router.push('/home')
      else this.$router.push({name: 'classes_to_me', query: {id: classesID}, params: {reload: 1}})
    },
    confirmMessage($title, $text, classesID = 0) {
      this.$modal.show('dialog', {
        title: $title,
        text: $text,
        class: 'col-md-6 col-12 box-popup-confirm',
        clickToClose: false,
        buttons: [
          {
            title: 'Đồng ý',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: () => {
              this.$modal.hide('dialog')
              setTimeout(() => {
                this.doHistoryBrowser(classesID)
              }, 100)
            }
          }
        ]
      })
    },
    async createJoinClassForUser() {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_JOIN_PC_USER_CLASSES),
        variables: {
          objWhere: {
            classes_id: {_eq: this.item[0].classes_id},
            pc_id: {_eq: this.item[0].pc_id},
            user_id: {_eq: this.$store.getters.user}
          },
          limit: 1
        }
      })
      if (data.pc_user === null || data.pc_user.length === 0) {
        var objInput = {
          pc_id: this.item[0].pc_id,
          user_id: this.$store.getters.user,
          is_delete: false,
          status: 2,
          classes_id: this.item[0].classes_id,
          position: this.item[0].position,
          un_pin: this.item[0].un_pin,
          un_pin_class: this.item[0].un_pin_class
        }
        await this.$apollo.mutate({
          mutation: gql(graphql.CREATE_USER_JOIN_TO_PC),
          variables: {objInput: objInput},
          update: (store, { data: { insert_pc_user } }) => {
            if (insert_pc_user.affected_rows) {
              this.isJoin = 1
              this.confirmMessage('Thông báo', 'Chào mừng bạn đã tham gia', 1)
            }
          }
        })
      } else {
        this.isJoin = 1
        this.confirmMessage('Thông báo', 'Chào mừng bạn đã tham gia', 1)
      }
    },
    clickOutSide (event) {
      if (event.target.className === 'v--modal-background-click') {
        this.doHistoryBrowser(this.isJoin)
      }
    },
    async checkUserJoinClass() {
      var params = this.$route.params
      if (params.id !== undefined && params.id !== null && !isNaN(params.id) && Number(params.id) > 0) {
        var classesID = Number(params.id)
        var classesAlias = params.alias
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_JOIN_PC_USER_CLASSES),
          variables: {
            objWhere: {
              classes_id: {'_eq': classesID}
            },
            limit: 1
          }
        })
        if (data.pc_user === null || data.pc_user.length === 0) {
          this.confirmMessage('Thông báo', 'Link tham gia này hiện không khả dụng')
        } else {
          this.item = data.pc_user
          if (this.item[0] !== undefined && this.item[0] !== null) {
            if (this.item[0].classes.private) {
              this.confirmMessage('Thông báo', 'Link tham gia này hiện không khả dụng')
            } else {
              if (!this.$store.getters.isLoggedIn) {
                var url = this.$route.path
                params = Object.assign(params, {name: this.$route.name})
                params = Object.assign(params, {id: classesID})
                params = Object.assign(params, {alias: classesAlias})
                params = Object.assign(params, {front_top: 1})
                params = Object.assign(params, {url: url})
                try {
                  this.$modal.show(LoginModal, {params: params}, {
                    // width: '43%',
                    height: 'auto',
                    classes: ['col-6'],
                    adaptive: true,
                    resize: true,
                    clickToClose: false
                  })
                } catch (e) {}
              } else {
                if (this.$store.getters.fullname.type_user === 2) {
                  this.confirmMessage('Thông báo', 'Tài khoản của bạn là giáo viên nên không thể tham gia lớp học.')
                } else if (this.$store.getters.fullname.type_user === 1) {
                  await this.createJoinClassForUser()
                }
              }
            }
          } else this.confirmMessage('Thông báo', 'Link tham gia này hiện không khả dụng')
        }
      } else this.confirmMessage('Thông báo', 'Link tham gia này hiện không khả dụng')
    }
  },
  async mounted () {
    document.body.addEventListener('click', this.clickOutSide, true)
    await this.checkUserJoinClass()
  },
  watch: {
    '$route': function(from, to) {
      if (from !== to) {
        this.checkUserJoinClass()
      }
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media screen and (min-width: 768px){
}
@media screen and (max-width: 768px){
}
</style>



// WEBPACK FOOTER //
// join.vue?1c0b79bb